import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { TrameHelper } from "@shared/helpers/trame.helper";
import { ContactFormService } from "@shared/services/contact-form.service";

@Component({
  selector: "app-comment-section",
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule],
  templateUrl: "./comment-section.component.html",
})
export class CommentSectionComponent {
  readonly comment: string = "comment";

  @Input() form!: FormGroup;
  @Input() spanMandatoryComment = false;

  constructor(private readonly contactFormService: ContactFormService) {}

  onCommentInput(event: Event) {
    const commentControl = this.form.get(this.comment);

    if (!commentControl) return;

    const inputElement = event.target as HTMLTextAreaElement;
    const currentValue = inputElement.value;

    const trame = this.contactFormService.getTrame(this.form);

    const newValue = TrameHelper.applyTramePrefix(currentValue, trame);
    commentControl.setValue(newValue);
  }

  onCommentKeyDown(event: KeyboardEvent) {
    const commentControl = this.form.get(this.comment);
    if (!commentControl) {
      return;
    }

    this.contactFormService.validateTrameKeyDown(event, this.form);
  }
}
